import { render, staticRenderFns } from "./Livros.vue?vue&type=template&id=2b16b642&"
import script from "./Livros.vue?vue&type=script&lang=js&"
export * from "./Livros.vue?vue&type=script&lang=js&"
import style0 from "./Livros.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports